<template>
  <video width="100%" height="100%" class="absolute" autoplay loop muted playsinline>
    <source v-for="[src, type] in sources" :key="src" :src="src" :type="type" />
    Sorry, your browser doesn't support embedded videos.
  </video>
</template>

<script>
export default {
  props: ['videoUrl', 'campaignId'],
  data: () => ({
    videoExtensions: ['mp4', 'webm'],
  }),
  computed: {
    sources() {
      return this.videoExtensions.map((extension) => [`${this.videoUrl}.${extension}`, `video/${extension}`]);
    },
  },
  mounted() {
    document.getElementsByClassName(`js-campaign-cover-photo-${this.campaignId}`)[0].remove();
  },
  methods: {},
};
</script>

<style lang="postcss"></style>
